import { gql } from '@apollo/client';
import { ContactFragment } from 'graphql/Contact/fragments/ContactFragment';
import { CurrencyFragment } from 'graphql/Currency/fragments/CurrencyFragment';
import { LanguageFragment } from 'graphql/Language/fragments/LanguageFragment';
import { LocationFragment } from 'graphql/Location/fragments/LocationFragment';
import { MediaFragment } from 'graphql/Media/fragments/MediaFragment';
/**
 * @fragment ClientFragment
 * @since 1.0.0
 */
export const ClientFragment = gql `
  fragment ClientFragment on Client {
    id
    name
    number
    isEndClient
    website
    discount
    visibility
    status
    storeEnabled
    formEnabled
    storeSlug
    voucherPrefix
    storeUrl
    formUrl
    createdAt
    updatedAt

    relatedClients {
      id
      name

      primaryLocation {
        ...LocationFragment
      }
    }

    childs {
      id
      name

      primaryLocation {
        ...LocationFragment
      }
    }

    owner {
      id
      firstname
      lastname
    }

    clientOwner {
      id
      name
    }

    contacts {
      ...ContactFragment
    }

    locations {
      ...LocationFragment
    }

    primaryLocation {
      ...LocationFragment
    }

    image {
      ...MediaFragment
    }

    medias {
      id
      type
      url
      media {
        ...MediaFragment
      }
    }

    headline
    introduction

    parent {
      id
      name
      primaryLocation {
        ...LocationFragment
      }
    }

    child {
      id
      name
      primaryLocation {
        ...LocationFragment
      }
    }

    currency {
      ...CurrencyFragment
    }

    language {
      ...LanguageFragment
    }

    externalData
  }

  ${ContactFragment}
  ${LocationFragment}
  ${MediaFragment}
  ${CurrencyFragment}
  ${LanguageFragment}
`;
